<template>
    <div class="adiv dflex pt15 pb50 htmldiv jc-between">
        <a href="https://zjiet.cjnep.net/sims/" target="_blank" class="a fs14 dinline-block prelative ofhidden cpointer">
            <img src="@/assets/images/jm_idx_03_01.png" class="wd100 dblock trans3 img" />
            <div class="p100 pabsolute dflex ai-center">
                <img src="@/assets/images/jm_idx_04_01.png" />
            </div>
        </a>
        <!-- <a href="https://jxjypx.zjiet.edu.cn/" target="_blank" class="a fs14 dinline-block prelative ofhidden cpointer">
            <img src="@/assets/images/jm_idx_03_01.png" class="wd100 dblock trans3 img" />
            <div class="p100 pabsolute dflex ai-center">
                <img src="@/assets/images/jm_idx_04_01.png" />
            </div>
        </a> -->
        <a href="http://zjiet.cjnep.net" target="_blank" class="a fs14 dinline-block prelative ofhidden cpointer">
            <img src="@/assets/images/jm_idx_03_02.png" class="wd100 dblock trans3 img" />
            <div class="p100 pabsolute dflex ai-center">
                <img src="@/assets/images/jm_idx_04_02.png" />
            </div>
        </a>
        <a href="https://www.cug.edu.cn/" target="_blank" class="a fs14 dinline-block prelative ofhidden cpointer">
            <img src="@/assets/images/jm_idx_03_03.png" class="wd100 dblock trans3 img" />
            <div class="p100 pabsolute dflex ai-center">
                <img src="@/assets/images/jm_idx_04_03.png" />
            </div>
        </a>
        <!-- <a href="http://www.cctvzsw.com/" target="_blank" class="a fs14 dinline-block prelative ofhidden cpointer">
            <img src="@/assets/images/jm_idx_03_04.png" class="wd100 dblock trans3 img" />
            <div class="p100 pabsolute dflex ai-center">
                <img src="@/assets/images/jm_idx_04_04.png" />
            </div>
        </a> -->
    </div>
</template>
<script>
export default {
    data() {
        return {
            trainList: []
        }
    }
}
</script>